import React from "react";

const testimonials = [
  {
    title: "Ephi",
    text: "Meet Bojan Antunovic and his crew from Decenter R&D, that hacked on Rootstock during ETH Global Brussels, building Ephi — a project aimed at making blockchain actions feel as easy as a single click.",
    name: "ETHGlobal Brussels",
    nameColor: "bg-yellow",
    readMoreUrl: "https://blog.rootstock.io/noticia/from-hackathon-hustle-to-big-ideas-blinkz/",
  },
  {
    title: "AnonMarket",
    text: "An innovative team of students from Paris that joined forces at ETHGlobal Bangkok 2024 to develop AnonMarket, a privacy-first prediction market platform that leverages Alice’s Ring signatures to ensure user anonymity.",
    name: "ETHGlobal Bangkok",
    nameColor: "bg-pink",
    readMoreUrl: "https://blog.rootstock.io/noticia/anonmarket-revolutionizing-privacy-in-predictive-markets-with-rootstocks-infrastructure/",
  },
  {
    title: "BitMate",
    text: "BitMate, an AI assistant designed to enhance the user experience in Bitcoin DeFi on Rootstock, simplifying interactions through natural language processing and making decentralized finance more accessible.",
    name: "Encode Bitcoin Bangkok",
    nameColor: "bg-orange",
    readMoreUrl: "https://rootstock.hashnode.dev/bitmate",
  },
];

export const Testimonials = () => {
  const renderCTA = (readMoreUrl) => (
    <div className="testimonial-cta">
      <a href={readMoreUrl} target="_blank" rel="noopener noreferrer" className="btn btn-outline-white mt-3">
        Read Blog Post
      </a>
    </div>
  );

  return (
    <section className="testimonials-section container">
      <div className="testimonial-header">
        <span className="zg-label bg-green mb-5">Spotlight</span>
        <h2 className="h3 mb-4">Success stories from Hackathon builders</h2>
      </div>
      <div className="testimonials-grid">
        {testimonials.map(({ title, text, name, nameColor, readMoreUrl }, index) => (
          <div key={index} className="testimonial-card">
            <div className="testimonial-name-wrapper">
              <span className={`testimonial-name mb-4 zg-label ${nameColor}`}>{name}</span>
            </div>
            <h3 className="h4 mb-4">{title}</h3>
            <p className="text">{text}</p>
            {renderCTA(readMoreUrl)}
          </div>
        ))}
      </div>
      <div className="testimonial-buttons container">
        <a
          href="https://dev.rootstock.io/"
          rel="noopener noreferrer"
          target="_blank"
          className="btn btn-outline-white btn-lg"
        >
          Developer Portal
        </a>
        <a
          href="https://discord.gg/rootstock"
          rel="noopener noreferrer"
          target="_blank"
          className="btn btn-outline-white btn-lg"
        >
        Join  Discord
        </a>
      </div>
    </section>
  );
};
